import { useEffect, useState, useCallback } from "react";
import apiClient from "../api/apiClient";
import apiPaths from "../api/endpoints";

export interface ResourceFile {
  name: string;
  url: string;
  theme: string;
  imageurl: string;
}

export interface ResourceDocument {
  complexity: string;
  files: ResourceFile[];
}

export interface ResourceCompetency {
  competency: string;
  documents: ResourceDocument[];
}

interface ResourcesApiResponse {
  status: number;
  data: ResourceCompetency[];
}

export function useGetResources() {
  const [data, setData] = useState<ResourceCompetency[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchResources = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await apiClient.get<ResourcesApiResponse>(apiPaths.GET_RESOURCES);
      setData(res.data?.data || []);
    } catch (err: any) {
      setError(
        err?.response?.data?.message || err?.message || "Failed to fetch resources"
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchResources();
  }, [fetchResources]);

  return { data, loading, error, refetch: fetchResources };
}
